import { VIEW_COLUMNS } from './columns';

export const VIEW_FILTERS = {
  [VIEW_COLUMNS.PRODUCT_NAME.id]: {
    ...VIEW_COLUMNS.PRODUCT_NAME,
    filterable: true,
  },
  [VIEW_COLUMNS.SKU.id]: {
    ...VIEW_COLUMNS.SKU,
    filterable: true,
  },
  [VIEW_COLUMNS.UPC.id]: {
    ...VIEW_COLUMNS.UPC,
    filterable: true,
  },
  [VIEW_COLUMNS.QTY.id]: {
    ...VIEW_COLUMNS.QTY,
    filterable: true,
  },
  [VIEW_COLUMNS.AVAILABLE_TO_SELL.id]: {
    ...VIEW_COLUMNS.AVAILABLE_TO_SELL,
    filterable: true,
  },
  [VIEW_COLUMNS.SHIP_TYPES.id]: {
    ...VIEW_COLUMNS.SHIP_TYPES,
    filterable: true,
  },
  [VIEW_COLUMNS.LEAD_TIME.id]: {
    ...VIEW_COLUMNS.LEAD_TIME,
    filterable: true,
  },
  [VIEW_COLUMNS.COST.id]: {
    ...VIEW_COLUMNS.COST,
    filterable: true,
  },
  [VIEW_COLUMNS.TOTAL_COST.id]: {
    ...VIEW_COLUMNS.TOTAL_COST,
    filterable: true,
  },
  [VIEW_COLUMNS.PRICE.id]: {
    ...VIEW_COLUMNS.PRICE,
    filterable: true,
  },
  [VIEW_COLUMNS.TOTAL_PRICE.id]: {
    ...VIEW_COLUMNS.TOTAL_PRICE,
    filterable: true,
  },
};

export const QUICK_FILTERS = [
  // {
  //   label: 'All Ship Types',
  //   value: 'all',
  // },
  {
    label: 'P Types',
    value: 'p',
  },
  // {
  //   label: 'S Types',
  //   value: 's',
  // },
  // {
  //   label: 'D Types',
  //   value: 'd',
  // },
  // {
  //   label: 'F Types',
  //   value: 'f',
  // },
  // {
  //   label: 'Not Only X Types',
  //   value: 'x',
  // },
  // {
  //   label: 'M Types',
  //   value: 'm',
  // },
];